import { render } from "./BathUpdate.vue?vue&type=template&id=59a11f74"
import script from "./BathUpdate.vue?vue&type=script&lang=js"
export * from "./BathUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__